<template>
  <div class="blacklistDisposal wrap">
      <!-- 黑名单列表 -->
      <div class="wrapper-box" :id="'black-'+index" v-for="(items,index) in listData" :key="'black'+index">
        <div class="info-box">
          <div class="title">{{items.listState == 'new' ? '黑名单监管中' : '退出黑名单监管'}}</div>
          <div class="date-box">
            <div class="starttime">{{items.happenedDate || items.createTime}} {{items.listState == 'new' ? '开始' : ''}}</div>
            <div class="endtime" v-if="items.listState == 'new'">剩余{{(items.leftTime && items.leftTime!= '-') ? items.leftTime : '-天-时-分钟'}}</div>
          </div>
        </div>
        <rline></rline>
        <listItem
          :label="'纳入原因'"
          :labelWidth="72"
          :ctnColor="'#333333'"
          :showRight="false"
        >{{items.disposeTypeDetail}}</listItem>
        <rline></rline>
        <listItem :label="'处理单位'" :labelWidth="72" :ctnColor="'#333333'" :showRight="false">{{items.dept }}</listItem>
        <rline></rline>
        <listItem :label="'处理人员'" :labelWidth="72" :ctnColor="'#333333'" :showRight="false">{{items.creatorName}}</listItem>
        <rline></rline>
        <div @click="goTravelRelatedPersonnel(items)">
          <listItem :label="'涉旅人员'" :labelWidth="72" :ctnColor="'#333333'"></listItem>
          <rline></rline>
        </div>
        <listItem :label="'备注'" :labelWidth="72" :ctnColor="'#333333'" :showRight="false">{{items.desc}}</listItem>
        <rline v-if="items.attach"></rline>
        <div v-if="items.attach" @click="items.attachList[0].accthPath.indexOf('.doc') == -1 ? goEnclosure(items.attachList): ''" >
          <listItem :label="'附件'" :labelWidth="72" :ctnColor="'#333333'"></listItem>
        </div>

      </div>
      <!-- 惩戒列表 -->
      <div class="wrapper-box" :id="'discipline-'+index" v-for="(items,index) in disciplineListData" :key="'discipline' + index">
        <div class="info-box">
          <div class="title">{{items.optionType == 0 ? '上线黑名单惩戒' : '退出黑名单惩戒'}}</div>
          <div class="date-box">
            <div class="starttime">{{items.disciplineDate }} {{items.optionType == 0 ? '开始' : ''}}</div>
            <div class="endtime" v-if="items.optionType == 0">剩余{{(items.leftTime && items.leftTime != '') ? items.leftTime : '-天-时-分钟'}}</div>
          </div>
        </div>
        <rline></rline>
        <listItem
          v-if="items.optionType !== 1"
          :label="'纳入原因'"
          :labelWidth="72"
          :ctnColor="'#333333'"
          :showRight="false"
        >{{items.disciplineTypeName}}</listItem>
        <rline></rline>
        <listItem :label="'处理单位'" :labelWidth="72" :ctnColor="'#333333'" :showRight="false">{{items.disposeDept}}</listItem>
        <rline></rline>
        <listItem :label="'处理人员'" :labelWidth="72" :ctnColor="'#333333'" :showRight="false">{{items.creatorName}}</listItem>
        <rline></rline>
        <listItem :label="'备注'" :labelWidth="72" :ctnColor="'#333333'" :showRight="false">{{items.disciplineDesc}}</listItem>
        <rline v-if="items.attachList && items.attachList.length > 0"></rline>
        <div v-if="items.attachList && items.attachList.length > 0" @click="items.attachList[0].accthPath.indexOf('.doc') == -1 ? $router.push('/travelAgency/enclosure?list=' + JSON.stringify(items.attachList)) : ''" >
          <listItem :label="'附件'" :labelWidth="72" :ctnColor="'#333333'"></listItem>
        </div>
      </div>
  </div>
</template>
<script>
    import listItem from './components/list-itemone';
    import rline from './components/line';
    import apimessage from '../../service/modules/message'

    import api from '../../service/modules/travel';
    export default {
        components: {
            rline,
            listItem
        },

        data () {
            return {
                bid: '',
                travelId: '',
                listData: [],
                disciplineListData: []
            };
        },

        computed: {},

        watch: {},

        methods: {
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                if (isRead === 'false') {
                    apimessage.messageReadOne({ messageId: id }).then(res => {
                        localStorage.setItem('messageId', id)
                    })
                }
            },
            // 附件跳转
            goEnclosure (item) {
                localStorage.travelEnclosureData = JSON.stringify(item)
                setTimeout(() => {
                    this.$router.push('/travelAgency/enclosure')
                }, 300)
            },
            // 社旅人员跳转
            goTravelRelatedPersonnel (item) {
                localStorage.travelRelatedPersonData = JSON.stringify(item)
                setTimeout(() => {
                    this.$router.push('/travelAgency/travelRelatedPersonnel')
                }, 300)
            },
            // 黑名单监管中

            async getBlackList (id) {
                await api.getBlackList({ travelId: id }).then(res => {
                    if (res.ret === 0) {
                        this.listData = res.data
                    }
                });
            },
            // 黑名单监管中（全国惩戒）
            async getDisciplineList (id) {
                await api.getDisciplineList({ travelId: id })
                    .then(res => {
                        if (res.ret === 0) {
                            this.disciplineListData = res.data;
                            this.targetPosition()
                        }
                    });
            },
            targetPosition () {
                this.$nextTick(() => {
                    let index = 0
                    // 黑名单
                    if (Number(this.type) === 1) {
                        this.listData.forEach((item, idx) => {
                            if (item.id === this.bid) {
                                index = idx
                            }
                        })

                        document.querySelector('.wrap').scrollTo({
                            top: document.querySelector('#black-' + index).offsetTop - 10

                        });
                    // 惩戒
                    } else if (Number(this.type) === 2) {
                        this.disciplineListData.forEach((item, idx) => {
                            if (item.id === this.bid) {
                                index = idx
                            }
                        })

                        document.querySelector('.wrap').scrollTo({
                            top: document.querySelector('#discipline-' + index).offsetTop - 10
                        });
                    }
                })
            },
            async getList () {
                this.bid = this.$route.query.bid || ''
                this.type = this.$route.query.type || ''
                await this.getBlackList(this.$route.query.id)
                await this.getDisciplineList(this.$route.query.id)
            }
        },

        mounted () {
            this.getList()
        },
        created () {
            let messageId = this.$route.query.messageId || ''
            let isRead = this.$route.query.isRead || 'true'
            this.onMessageReadOne(isRead, messageId)
        }
    };
</script>
<style scoped lang="less">
.blacklistDisposal {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: rgba(251, 251, 251, 1);
  box-sizing: border-box;
  padding-top: 16px;
  .wrapper-box {
    width: 351px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin: 0 12px;
    overflow: hidden;
    margin-bottom: 12px;

    .info-box {
      box-sizing: border-box;
      padding: 16px;

      .title {
        font-size: 14px;
        font-family: PingFang SC,Arial,sans-serif;
        -webkit-font-smoothing: antialiased;
        font-weight: 700;
        color: rgba(51, 51, 51, 1);
        line-height: 14px;
        margin-bottom: 7px;
      }
      .date-box {
        height: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .starttime,
        .endtime {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 14px;
        }
      }
    }
  }
  .spa-wrapper-box {
    margin-top: 12px;
  }
}
</style>
